




















import { Component, Vue, Prop } from "vue-property-decorator";
import PageHeader from "@/components/PageHeader.vue";
import VPageContentSticky from "@/components/VPageContentSticky.vue";

@Component({ components: { PageHeader, VPageContentSticky } })
export default class TablePage extends Vue {
  @Prop()
  readonly title;

  @Prop()
  readonly fullwidth;

  @Prop({ default: true })
  readonly showHeader: boolean;

  @Prop({ default: "" })
  readonly headerClass: string | { [key: string]: boolean };

  goBack() {
    this.$router.back();
  }
}
